import moment from 'moment';

export function OrderDateTimeController(
    $q,
    $scope,
    CALENDAR_STRINGS,
    FULFILLMENT_TYPES,
    availabilitiesFactory,
    cartDisplayService,
    googleAnalyticsTrackingService,
    restaurantHoursService,
    restaurantInfoFactory
) {
    'ngInject';
    var vm = this;
    vm.cartDisplay = {};
    vm.minDate = null;
    vm.openPopup = openPopup;
    vm.datePickerOptions = { formatYear: 'yy', startingDay: 1 };
    vm.flags = {};
    vm.dateFlags = {};
    vm.updateTime = updateTime;
    vm.onDateChange = onDateChange;
    vm.isSelected = isSelected;
    vm.timezone = null;
    vm.days = [];

    //Exported for testing
    vm.updateTimeList = updateTimeList;
    vm.clearTimeList = clearTimeList;

    activate();

    ///------------------------

    function openPopup() {
        vm.popupOpen = true;
    }

    /**
     * @returns {Promise<void>}
     */
    function _buildDatesAndTimes() {
        _setCalendarDateRange();
        _clearDisabledDates();
        return _setupDayList()
            .then(_getOrderTimes);
    }

    function onDiningOptionChange(newValue, oldValue){
        if (newValue !== oldValue) {
            _buildDatesAndTimes();
        }
    }

    function _clearDisabledDates() {
        vm.disabledDates = [];
    }

    function onDateChange() {
        cartDisplayService.setDate(vm.selectedDate)
            .then(_getOrderTimes);
    }

    /**
     * @returns {Promise<void>}
     */
    function _getOrderTimes() {
        return availabilitiesFactory.getOrderTimes(vm.cartDisplay.fulfillmentMoment, vm.cartDisplay.diningOption)
            .then(vm.updateTimeList)
            .catch(vm.clearTimeList);
    }

    /**
     * @returns {Promise<void>}
     */
    function updateTimeList(orderTimes) {
        vm.orderTimes = orderTimes;
        var tempOption = cartDisplayService.getFulfillmentTime();
        if(vm.cartDisplay.fulfillmentType === FULFILLMENT_TYPES.ASAP && orderTimes[0] === FULFILLMENT_TYPES.ASAP) {
            vm.selectedTime = orderTimes[0];
        } else {
            vm.selectedTime = orderTimes.indexOf(tempOption) !== -1 ? tempOption : orderTimes[0];
        }
        return updateTime();
    }

    function clearTimeList() {
        vm.orderTimes = [];
    }

    /**
     * @returns {Promise<void>}
     */
    function updateTime() {
        googleAnalyticsTrackingService.trackDateTimeChange();

        return cartDisplayService.setTime(vm.selectedTime);
    }

    function isSelected(date) {
        return vm.cartDisplay.fulfillmentMoment.isSame(date, 'day');
    }

    function _setCartDisplayData(data) {
        vm.scheduledOrderMaxDaysDefault = data.onlineOrder.scheduledOrderMaxDaysDefault;
        vm.scheduledOrderMaxDays = data.onlineOrder.scheduledOrderMaxDays;
        vm.cartDisplay = cartDisplayService.displayData;

        _buildDatesAndTimes();
    }

    /**
     * @returns {Promise<*>}
     */
    function _setupDayList() {
        vm.days = [];
        var initial = availabilitiesFactory.getInitialDateTime();

        let doAddAvailableDatesToList = i => {
            const date = angular.copy(vm.cartDisplay.minMoment).add(i, 'days');
            const formatted = moment(date).calendar(initial, CALENDAR_STRINGS);
            return availabilitiesFactory
                .getStartEndTimes(date, cartDisplayService.displayData.diningOption)
                .then(
                    times => restaurantHoursService.firstValidServicePeriod(times, cartDisplayService.displayData.diningOption),
                    () => {
                        vm.disabledDates.push(date);
                        return null;
                    }
                )
                .then(time => {
                    if (time !== null) {
                        vm.days.push({ string: formatted, date: date.format() });
                    } else {
                        vm.disabledDates.push(date);
                    }

                    return _selectDateOrKeepSearching(i, doAddAvailableDatesToList);
                });
        };

        return doAddAvailableDatesToList(0);
    }

    /**
     *
     * @param {number} i
     * @param {function} doAddAvailableDatesToList
     * @returns {Promise<void>}
     */
    function _selectDateOrKeepSearching(i, doAddAvailableDatesToList) {
        if (i < vm.scheduledOrderMaxDays) {
            return doAddAvailableDatesToList(i + 1);
        }

        return _selectFirstDateAndTime();
    }

    /**
     * @returns {Promise<void>}
     */
    function _selectFirstDateAndTime() {
        let found = false;

        for (let j = 0; j < vm.days.length; j++) {
            if (moment.parseZone(vm.cartDisplay.fulfillmentMoment).isSame(vm.days[j].date, 'day')) {
                found = true;
                vm.selectedDate = vm.days[j].date;
            }
        }

        if (found) {
            return $q.resolve();
        }

        vm.selectedDate = vm.days[0].date;
        return cartDisplayService.setDate(vm.selectedDate);
    }

    function _setCalendarDateRange() {
        vm.minDate = vm.cartDisplay.minMoment.toDate();
        vm.maxDate = angular.copy(vm.cartDisplay.minMoment).add(vm.scheduledOrderMaxDays, 'days').toDate();
    }

    function activate() {
        restaurantInfoFactory.getInfo(['onlineOrder', 'general']).then(info => {
            cartDisplayService.getDisplayData().finally(() => {
                _setCartDisplayData(info);

                $scope.$watch(
                    () => vm.cartDisplay.diningOption,
                    (newVal, oldVal) => {
                        onDiningOptionChange(newVal, oldVal);
                    }
                );
            });

            vm.timezone = info.general.timeZone;
        });
    }
}
